import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import ItineraryForm from "./Components/ItineraryForm";
import { checkExistCustomerEnquiry, getCustomerDataById, getUpcomingItinerary } from "../../../api/customer.api";
import ItineraryDetailsCard from "./Components/ItineraryDetailsCard";
import ModalWrapper from "../../../components/ModalWrapper/ModalWrapper";
import PreviewItineraryModal from "../../../components/Modals/PreviewItineraryModal/PreviewItineraryModal";
import { createEnquiryByItineraryId, getItinerarybyEnquiryId, previewItinerary, searchItinerary } from "../../../api/itinerary.api";
import ItinerarySuccessModal from "../../../components/Modals/ItinerarySuccessModal/ItinerarySuccessModal";
import { SelectedUserContext } from "../../../context/selecteduser.context";
import dayjs from "dayjs";
import { every, isEmpty, isNil, sortBy } from "lodash";
import { SortIconSvg } from "../../../assets/svg";
import "../style.scss";
import { useParams } from "react-router-dom";

interface ISelectItinerary {
  setStepNumber: Dispatch<SetStateAction<number>>;
}

const SelectItinerary: React.FC<ISelectItinerary> = ({ setStepNumber }) => {
  const { customerId } = useParams();
  const { selectedUser, handleSelectedUser, existingEnquiry, handleExistingEnquiry } = useContext(SelectedUserContext);
  const [itineraryData, setItineraryData] = useState<any[]>([]);
  const [itineraryType, setItineraryType] = useState("upcoming");
  const [itineraryIdsArr, setItineraryIdsArr] = useState<string[]>([]);
  const [modalViewState, setModalViewState] = useState<boolean>(false);
  const [modalSuccessState, setModalSuccessState] = useState<boolean>(false);
  const [previewData, setPreviewData] = useState({});
  const [upcomingSelectedItinerary, setUpcomingSelectedItinerary] = useState<string>('');
  const [currentSortCol, setCurrentSortCol] = useState('start_time');

  useEffect(() => { 
    const fetchData = async () => {
      if (customerId && !selectedUser?.email) {
        const data = await getCustomerDataById(customerId);
        if (data?.status === 200) {
          let userData = data?.result;
          handleSelectedUser(userData);
        }
        const existEnquiry = await checkExistCustomerEnquiry(customerId);
      if (existEnquiry.status === 200) handleExistingEnquiry(existEnquiry?.result);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!!selectedUser?.email) isEmpty(existingEnquiry) ? fetchUpcomingItinerary() : fetchAvailableItineries();
  }, [existingEnquiry]);
  
  const fetchUpcomingItinerary = async () => {
    const data = await getUpcomingItinerary();
    if (data.status === 200) {
      setItineraryData(data?.result);
    }
  };

  const fetchAvailableItineries = async () => { 
    const { enquiryPref } = existingEnquiry;
    enquiryPref.departureId = enquiryPref?.departure?.id;
    enquiryPref.destinationId = enquiryPref?.destination?.id;
    const allEmptyValues = every(enquiryPref, (value, key) => key !== 'nightCount' ? isNil(value) : isEmpty(value));
    const response = await getItinerarybyEnquiryId(existingEnquiry?.id);
    if (response?.status === 200 || response?.status === 201) {
      if (!response?.result?.result?.length || allEmptyValues) {
        fetchUpcomingItinerary();
        setItineraryType("available");
      }
      const existingItineraryIdsArr = response?.result?.result?.map((itineraryDetail: any) => itineraryDetail?.id);
      setItineraryIdsArr([...existingItineraryIdsArr]);
    }
    if (!allEmptyValues) {
      const availableItinerary = await searchItinerary(cleanPayload(enquiryPref));
      setItineraryData(availableItinerary?.result?.result);
      setItineraryType("available");
    }
  }
  
  const handlePreviewClick = async () => {
    const data = await previewItinerary(itineraryIdsArr);
    if (data?.status === 200) {
      setPreviewData(data?.result);
      toggleDetailsModal();
    }
  };
  
  const handleEnquiryTrigger = async (payloadValues: any) => {
    const payload = {
      startDate: dayjs(payloadValues?.start_time).format("DD MMM YYYY"),
      endDate: dayjs(payloadValues?.end_time).format("DD MMM YYYY"),
      departureId: payloadValues?.origin_port_id,
      destinationId: payloadValues?.destination_port_id,
      tripType: payloadValues?.trip_type,
      shipId: payloadValues?.ship_id,
      nightCount: [payloadValues?.night_count],
    };

    const data = await createEnquiryByItineraryId({
      customerId: selectedUser?.id,
      itineraryId: payloadValues?.id,
    });

    if (data?.status === 201) {
      const availableItinerary = await searchItinerary(payload);
      const { result } = availableItinerary?.result || { result: [] };

      const filterUpcomingSelectedItinerary = result.filter((itinerary: any) => itinerary?.id === upcomingSelectedItinerary);
      const filterAvailableItinerary = result.filter((itinerary: any) => itinerary?.id !== upcomingSelectedItinerary);
  
      setItineraryData([...filterUpcomingSelectedItinerary, ...filterAvailableItinerary]);
      handleExistingEnquiry(data?.result);
      setItineraryType("available");
    }
  };
  
  const handleItineraryDataSort = (keyName: string) => {
    if (keyName === currentSortCol) {
      const revArr = [...itineraryData].reverse()
      setItineraryData(revArr);
    } else {
      const sortedArr = sortBy(itineraryData, keyName);
      setItineraryData(sortedArr);
    }
    setCurrentSortCol(keyName);
  }

  const cleanPayload = (payloadObj: any) => {
    const filteredPayload = {...payloadObj}
    Object.keys(filteredPayload).forEach((key) => {
      if (filteredPayload[key] === undefined || filteredPayload[key] === null || filteredPayload[key] === "") {
        delete filteredPayload[key];
      }
    });
    return filteredPayload;
  };
  
  const toggleDetailsModal = () => {
    setModalViewState((prev) => !prev);
  };

  const toggleSuccessModal = () => {
    setModalSuccessState((prev) => !prev);
  };

  return (
    <div className="text-nowrap">
      {/* <MyStepper currentStep={"select-itinerary"}/> */}
      <Row className=" border bg-white rounded m-h-[483px] w-100 m-0">
        <Col className="px-4 py-5 flex flex-col gap-3">         
          <ItineraryForm setItineraryData={setItineraryData} itineraryIdsArr={itineraryIdsArr} setItineraryIdsArr={setItineraryIdsArr} cleanPayload={ cleanPayload } />
        </Col>
      </Row>
      <Row className="my-5 border bg-white rounded m-h-[483px] w-100 m-0">
        <Col className="py-10 px-4">
          <h2 className="text-uppercase" style={{ fontWeight: "700", fontSize: "22px", lineHeight: "28.64px" }}>
            {itineraryType} Itineraries
          </h2>
          <div className="d-flex justify-content-between align-items-center ps-3 bg-[#FAFAFA]  border rounded my-4 py-2 ">
            <div className="w-[32px]"></div>
            <Row className="w-100 m-0 ">
              <Col xs={4}>
                <span onClick={() => handleItineraryDataSort('start_time')} className="d-flex align-items-center cursor-pointer">Date &nbsp; <SortIconSvg/></span>
              </Col>
              <Col xs={2}>
                <span onClick={() => handleItineraryDataSort('trip_type')} className="d-flex align-items-center cursor-pointer ml-2">Type &nbsp; <SortIconSvg/></span>
              </Col>
              <Col>
                <span onClick={() => handleItineraryDataSort('night_count')} className="d-flex align-items-center cursor-pointer ml-2">Nights &nbsp; <SortIconSvg/></span>
              </Col>
              {/* <Col className="d-flex align-items-center">
                Demand &nbsp; <SortIconSvg/>
              </Col> */}
            </Row>
          </div>
          <div className="max-h-[50vh] -ml-1" style={{ overflowY: "scroll", overflowX: "hidden" }}>
            {!!itineraryData?.length &&
              itineraryData?.map((item) => {
                return (
                  <div key={item?.id}>
                    <ItineraryDetailsCard
                      item={item}
                      itineraryType={itineraryType}
                      handleEnquiryTrigger={handleEnquiryTrigger}
                      itineraryIdsArr={itineraryIdsArr}
                      setItineraryIdsArr={setItineraryIdsArr}
                      setUpcomingSelectedItinerary={setUpcomingSelectedItinerary}
                    />
                  </div>
                );
              })}
            {!itineraryData?.length && <p className="w-100 text-2xl text-center">No itinerary found !</p> }
          </div>
          <Row className="m-0 mt-4 ">
            <Col className="flex justify-content-end">
              <button
                className="text-light btn"
                onClick={handlePreviewClick}
                style={{ background: "linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%)" }}
                disabled = {!itineraryIdsArr.length}
              >
                Preview
              </button>
            </Col>
          </Row>
        </Col>
      </Row>
      <ModalWrapper show={modalViewState} handleClose={toggleDetailsModal} clx={'w-[80vw]'}>
        <PreviewItineraryModal
          previewData={previewData}
          setStepNumber={setStepNumber}
          handleSuccessModal={toggleSuccessModal}
          handleDetailsModal={toggleDetailsModal}
        />
      </ModalWrapper>
      <ModalWrapper show={modalSuccessState} handleClose={toggleSuccessModal}>
        <ItinerarySuccessModal setStepNumber={setStepNumber} />
      </ModalWrapper>
    </div>
  );
};

export default SelectItinerary;
